<div class="min-h-screen p-6 backdrop-blur-sm animate-fade-in-up">
  <!-- Header Control Panel -->
  <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">
    <div>
      <h1 class="text-2xl font-extrabold text-slate-800 dark:text-slate-100 flex items-center gap-2">
        <span class="material-icons text-amber-500 text-3xl">analytics</span>
        รายงานใบกำกับภาษีเต็มรูป (Full Tax Invoice Report)
      </h1>
      <p class="text-sm text-slate-500 dark:text-slate-400 mt-1">
        จัดการข้อมูลส่งออกใบกำกับภาษีเต็มรูปเข้าระบบรายงานเพื่อประมวลผล PDF
      </p>
    </div>

    <!-- Refresh Button -->
    <div class="flex items-center gap-3">
      <div *ngIf="lastFetchedTime" class="flex flex-col items-end text-right">
        <span class="text-[11px] text-slate-400 dark:text-slate-500 font-medium leading-none mb-1">ดึงข้อมูลล่าสุด</span>
        <span class="text-[13px] font-bold text-slate-600 dark:text-slate-400 leading-none">{{ lastFetchedTime | date:'HH:mm:ss' }}</span>
      </div>
      <button (click)="onRefresh()"
        class="flex items-center gap-2 px-4 py-2.5 bg-white dark:bg-slate-800 border border-slate-200/80 dark:border-slate-700 rounded-xl text-sm font-semibold text-slate-700 dark:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors shadow-sm">
        <span class="material-icons text-slate-500 dark:text-slate-400">sync</span>
        รีเฟรช
      </button>
    </div>
  </div>

  <!-- Main Table Section -->
  <div
    class="bg-white/95 dark:bg-slate-800/95 border border-slate-100/50 dark:border-slate-700/50 rounded-[2rem] shadow-2xl p-6 relative overflow-hidden backdrop-blur-sm">
    <!-- Table Control Bar -->
    <div class="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6">
      <!-- Search Field with Type Selector Combo Box -->
      <div
        class="flex items-center bg-slate-100/80 dark:bg-slate-900/80 border border-slate-200/50 dark:border-slate-700 rounded-xl px-3 py-1.5 focus-within:ring-2 focus-within:ring-amber-400/50 focus-within:border-amber-400 w-full md:max-w-md transition-all">
        <span class="material-icons text-slate-400 mr-2">search</span>
        <input type="text" [(ngModel)]="searchText" (ngModelChange)="onSearchChange()"
          [placeholder]="'ค้นหาด้วย ' + currentSearchTypeLabel + '...'"
          class="w-full bg-transparent border-none outline-none text-sm text-slate-700 dark:text-slate-200 placeholder-slate-400 font-medium" />

        <!-- Search Type Dropdown Selector -->
        <div class="relative ml-2 border-l border-slate-300 dark:border-slate-600 pl-2">
          <button (click)="toggleSearchTypeDropdown()" (blur)="closeSearchTypeDropdown()"
            class="flex items-center gap-1 text-xs w-18 font-bold text-slate-500 dark:text-slate-400 hover:text-slate-800 dark:hover:text-slate-200 focus:outline-none cursor-pointer">
            <span>{{ currentSearchTypeLabel }}</span>
            <span class="material-icons text-sm transition-transform duration-200"
              [class.rotate-180]="isSearchTypeDropdownOpen">arrow_drop_down</span>
          </button>

          <div *ngIf="isSearchTypeDropdownOpen" (mousedown)="$event.preventDefault()"
            class="absolute right-0 mt-2 z-30 w-48 bg-white/95 dark:bg-slate-800 border border-slate-100/50 dark:border-slate-700 rounded-xl shadow-xl py-1 backdrop-blur-sm animate-fade-in">
            <button (click)="selectSearchType('customerName')"
              class="w-full text-left px-4 py-2.5 text-xs font-semibold text-slate-700 dark:text-slate-200 hover:bg-amber-50 dark:hover:bg-slate-700 hover:text-amber-600 transition-colors flex items-center justify-between cursor-pointer">
              <span>ชื่อลูกค้า</span>
              <span class="material-icons text-xs text-amber-500 font-bold"
                *ngIf="searchType === 'customerName'">check</span>
            </button>
            <button (click)="selectSearchType('receiptId')"
              class="w-full text-left px-4 py-2.5 text-xs font-semibold text-slate-700 dark:text-slate-200 hover:bg-amber-50 dark:hover:bg-slate-700 hover:text-amber-600 transition-colors flex items-center justify-between cursor-pointer">
              <span>เลขที่ใบกำกับภาษี</span>
              <span class="material-icons text-xs text-amber-500 font-bold"
                *ngIf="searchType === 'receiptId'">check</span>
            </button>
            <button (click)="selectSearchType('taxId')"
              class="w-full text-left px-4 py-2.5 text-xs font-semibold text-slate-700 dark:text-slate-200 hover:bg-amber-50 dark:hover:bg-slate-700 hover:text-amber-600 transition-colors flex items-center justify-between cursor-pointer">
              <span>เลขประจำตัวผู้เสียภาษี</span>
              <span class="material-icons text-xs text-amber-500 font-bold" *ngIf="searchType === 'taxId'">check</span>
            </button>
          </div>
        </div>
      </div>

      <!-- Advanced Filter Toggle -->
      <button (click)="toggleTableFilters()" [class.bg-amber-400]="showTableFilters"
        [class.text-slate-900]="showTableFilters" [class.border-amber-400]="showTableFilters"
        class="flex items-center justify-center gap-2 px-5 py-2.5 bg-white dark:bg-slate-900 border border-slate-200/80 dark:border-slate-700 rounded-xl text-sm font-bold text-slate-700 dark:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors shadow-sm self-end md:self-auto cursor-pointer">
        <span class="material-icons text-lg">filter_list</span>
        ตัวกรองขั้นสูง
      </button>
    </div>

    <!-- Advanced Horizontal Collapsible Filter Panel -->
    <div *ngIf="showTableFilters"
      class="p-5 bg-slate-50/50 dark:bg-slate-900/40 border border-slate-100/50 dark:border-slate-700/50 rounded-2xl mb-6 grid grid-cols-1 md:grid-cols-3 gap-6 animate-fade-in">

      <!-- Custom Select (Searchable Autocomplete Dropdown / Combo Box) for Customer Name -->
      <div class="flex flex-col gap-1.5">
        <label class="text-xs font-bold text-slate-500 dark:text-slate-400">กรองตามชื่อลูกค้า</label>
        <div class="relative w-full">
          <div
            class="flex items-center w-full px-4 py-2.5 bg-white dark:bg-slate-800 border border-slate-200/80 dark:border-slate-700 rounded-xl focus-within:ring-2 focus-within:ring-amber-400/50 focus-within:border-amber-400 transition-all">
            <input type="text" [(ngModel)]="searchFieldText" (focus)="toggleCustomerDropdown()"
              (blur)="closeDropdowns()" placeholder="พิมพ์ชื่อลูกค้าเพื่อค้นหา..."
              class="w-full bg-transparent outline-none text-slate-700 dark:text-slate-200 text-sm font-semibold placeholder-slate-400" />

            <button *ngIf="selectedCustomerFilter !== 'all'"
              (click)="clearCustomerSelection(); $event.stopPropagation()"
              class="material-icons text-slate-400 hover:text-slate-650 text-sm cursor-pointer mr-1 focus:outline-none">clear</button>
            <span class="material-icons text-slate-400 cursor-pointer transition-transform duration-200"
              [class.rotate-180]="isCustomerDropdownOpen" (click)="toggleCustomerDropdown()">arrow_drop_down</span>
          </div>

          <!-- Dropdown container -->
          <div *ngIf="isCustomerDropdownOpen" (mousedown)="$event.preventDefault()"
            class="absolute z-50 w-full mt-1.5 bg-white/95 dark:bg-slate-800 border border-slate-100/50 dark:border-slate-700 rounded-xl shadow-xl max-h-48 overflow-y-auto custom-scrollbar backdrop-blur-sm animate-fade-in">
            <div *ngIf="filteredOptions.length === 0" class="px-4 py-3 text-sm text-slate-400 text-center font-medium">
              ไม่พบรายชื่อลูกค้า
            </div>
            <div *ngFor="let opt of filteredOptions" (click)="selectCustomerOption(opt)"
              class="px-4 py-2.5 text-xs font-semibold text-slate-700 dark:text-slate-200 hover:bg-amber-50 dark:hover:bg-slate-700 hover:text-amber-600 cursor-pointer transition-colors duration-150 flex items-center justify-between">
              <span>{{ opt }}</span>
              <span class="material-icons text-xs text-amber-500 font-bold"
                *ngIf="selectedCustomerFilter === opt">check</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Angular Material Datepicker Range Selection -->
      <div class="flex flex-col gap-1.5">
        <label class="text-xs font-bold text-slate-500 dark:text-slate-400">วันที่เริ่มต้น - วันที่สิ้นสุด</label>
        <div
          class="flex items-center gap-2 px-4 py-[2px] bg-white dark:bg-slate-800 border border-slate-200/80 dark:border-slate-700 rounded-xl focus-within:ring-2 focus-within:ring-amber-400/50 focus-within:border-amber-400 transition-all shadow-sm">
          <mat-date-range-input [rangePicker]="picker" class="text-sm font-semibold text-slate-700 dark:text-slate-200 w-full">
            <input matStartDate [(ngModel)]="startDate" (dateChange)="onDateChange()" placeholder="เริ่ม">
            <input matEndDate [(ngModel)]="endDate" (dateChange)="onDateChange()" placeholder="สิ้นสุด">
          </mat-date-range-input>
          <mat-datepicker-toggle matIconSuffix [for]="picker"
            class="text-slate-400 hover:text-amber-500 cursor-pointer"></mat-datepicker-toggle>
          <mat-date-range-picker #picker panelClass="modern-yellow-datepicker"></mat-date-range-picker>
        </div>
      </div>

      <!-- Status Dropdown filter -->
      <div class="flex flex-col gap-1.5">
        <label class="text-xs font-bold text-slate-500 dark:text-slate-400">สถานะ</label>
        <div class="relative w-full">
          <button (click)="toggleStatusDropdown()" (blur)="closeStatusDropdown()"
            class="flex items-center justify-between w-full px-4 py-2.5 bg-white dark:bg-slate-800 border border-slate-200/80 dark:border-slate-700 rounded-xl text-sm font-semibold text-slate-700 dark:text-slate-200 outline-none focus:ring-2 focus:ring-amber-400/50 focus:border-amber-400 transition-all text-left shadow-sm cursor-pointer">
            <span>{{ getStatusLabel(filterStatus) }}</span>
            <span class="material-icons text-slate-400 transition-transform duration-200"
              [class.rotate-180]="isStatusDropdownOpen">arrow_drop_down</span>
          </button>

          <div *ngIf="isStatusDropdownOpen" (mousedown)="$event.preventDefault()"
            class="absolute z-50 w-full mt-1.5 bg-white/95 dark:bg-slate-800 border border-slate-100/50 dark:border-slate-700 rounded-xl shadow-xl py-1 backdrop-blur-sm animate-fade-in">
            <button (click)="selectStatus('all')"
              class="w-full text-left px-4 py-2.5 text-xs font-semibold text-slate-700 dark:text-slate-200 hover:bg-amber-50 dark:hover:bg-slate-700 hover:text-amber-600 transition-colors flex items-center justify-between cursor-pointer">
              <span>ทั้งหมด</span>
              <span class="material-icons text-xs text-amber-500 font-bold" *ngIf="filterStatus === 'all'">check</span>
            </button>
            <button (click)="selectStatus('0')"
              class="w-full text-left px-4 py-2.5 text-xs font-semibold text-slate-700 dark:text-slate-200 hover:bg-amber-50 dark:hover:bg-slate-700 hover:text-amber-600 transition-colors flex items-center justify-between cursor-pointer">
              <span>รอดำเนินการ</span>
              <span class="material-icons text-xs text-amber-500 font-bold" *ngIf="filterStatus === '0'">check</span>
            </button>
            <button (click)="selectStatus('1')"
              class="w-full text-left px-4 py-2.5 text-xs font-semibold text-slate-700 dark:text-slate-200 hover:bg-amber-50 dark:hover:bg-slate-700 hover:text-amber-600 transition-colors flex items-center justify-between cursor-pointer">
              <span>ยืนยันแล้ว</span>
              <span class="material-icons text-xs text-amber-500 font-bold" *ngIf="filterStatus === '1'">check</span>
            </button>
            <button (click)="selectStatus('2')"
              class="w-full text-left px-4 py-2.5 text-xs font-semibold text-slate-700 dark:text-slate-200 hover:bg-amber-50 dark:hover:bg-slate-700 hover:text-amber-600 transition-colors flex items-center justify-between cursor-pointer">
              <span>ยกเลิก</span>
              <span class="material-icons text-xs text-amber-500 font-bold" *ngIf="filterStatus === '2'">check</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Table Core Container -->
    <div class="overflow-x-auto rounded-xl border border-slate-100/50 dark:border-slate-700/50 custom-scrollbar mb-6">
      <table class="w-full border-collapse text-left">
        <thead>
          <tr
            class="bg-slate-50/80 dark:bg-slate-900/80 text-slate-500 dark:text-slate-400 border-b border-slate-100 dark:border-slate-700 text-xs font-bold uppercase tracking-wider">
            <th (click)="sortData('receiptId')"
              class="px-6 py-4 cursor-pointer hover:bg-slate-100 dark:hover:bg-slate-700/50 transition-colors select-none">
              เลขที่ใบกำกับภาษี
              <span class="material-icons text-sm align-middle ml-1" *ngIf="sortColumn === 'receiptId'">
                {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
              </span>
            </th>
            <th (click)="sortData('customerName')"
              class="px-6 py-4 cursor-pointer hover:bg-slate-100 dark:hover:bg-slate-700/50 transition-colors select-none">
              ลูกค้า / บริษัท
              <span class="material-icons text-sm align-middle ml-1" *ngIf="sortColumn === 'customerName'">
                {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
              </span>
            </th>
            <th class="px-6 py-4">ไซต์โครงการ</th>
            <th (click)="sortData('createBill')"
              class="px-6 py-4 cursor-pointer hover:bg-slate-100 dark:hover:bg-slate-700/50 transition-colors select-none text-center">
              วันที่เอกสาร
              <span class="material-icons text-sm align-middle ml-1" *ngIf="sortColumn === 'createBill'">
                {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
              </span>
            </th>
            <th (click)="sortData('total')"
              class="px-6 py-4 cursor-pointer hover:bg-slate-100 dark:hover:bg-slate-700/50 transition-colors select-none text-right">
              จำนวนเงินรวม (บาท)
              <span class="material-icons text-sm align-middle ml-1" *ngIf="sortColumn === 'total'">
                {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
              </span>
            </th>
            <th class="px-6 py-4 text-center">สถานะ</th>
            <th class="px-6 py-4 text-center">ดำเนินการ</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-slate-100 dark:divide-slate-700 text-sm">
          <tr *ngIf="invoices.length === 0" class="hover:bg-slate-50/50 dark:hover:bg-slate-700/40">
            <td colspan="7" class="px-6 py-10 text-center text-slate-400 font-medium">
              <span class="material-icons text-3xl block mb-2 text-slate-300 dark:text-slate-600">receipt</span>
              ไม่พบรายการใบกำกับภาษี
            </td>
          </tr>

          <tr *ngFor="let item of invoices" class="hover:bg-amber-50/40 dark:hover:bg-slate-700/40 transition-colors duration-150">
            <td class="px-6 py-4 font-bold text-slate-800 dark:text-slate-100">{{ item.receiptId }}</td>
            <td class="px-6 py-4">
              <div class="font-semibold text-slate-700 dark:text-slate-200">{{ item.customerName }}</div>
              <div class="text-xs text-slate-400 truncate max-w-xs mt-0.5" [title]="item.details">{{ item.details }}
              </div>
            </td>
            <td class="px-6 py-4">
              <div class="font-semibold text-slate-600 dark:text-slate-300">{{ item.siteName }}</div>
            </td>
            <td class="px-6 py-4 text-center font-medium text-slate-600 dark:text-slate-300">{{ formatDateDisplay(item.createBill) }}</td>
            <td class="px-6 py-4 text-right font-bold text-slate-800 dark:text-slate-100">
              {{ item.total | number:'1.2-2' }}
            </td>
            <td class="px-6 py-4 text-center">
              <span class="inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-bold border"
                [ngClass]="getStatusConfig(item.status).class">
                <span class="material-icons text-xs">{{ getStatusConfig(item.status).icon }}</span>
                {{ getStatusConfig(item.status).label }}
              </span>
            </td>
            <td class="px-6 py-4 text-center">
              <div class="flex items-center justify-center gap-2">
                <!-- Edit Button -->
                <button (click)="openEditModal(item)" [disabled]="isLoading || !isFullTaxInvoiceEditable(item.status)"
                  [title]="isFullTaxInvoiceEditable(item.status) ? 'แก้ไข' : 'ยืนยันแล้ว แก้ไขไม่ได้'"
                  class="w-8 h-8 flex items-center justify-center bg-white dark:bg-slate-800 hover:bg-slate-50 dark:hover:bg-slate-700 border border-slate-200 dark:border-slate-600 text-amber-500 rounded-lg shadow-sm transition-all disabled:opacity-40 disabled:cursor-not-allowed">
                  <span class="material-icons text-sm">edit</span>
                </button>

                <!-- Confirm Button -->
                <button *ngIf="isFullTaxInvoiceEditable(item.status)" (click)="openConfirmModal(item)"
                  [disabled]="isLoading"
                  class="inline-flex items-center gap-1 px-3 py-1.5 bg-emerald-500 hover:bg-emerald-600 disabled:opacity-50 disabled:cursor-not-allowed text-xs font-bold text-white rounded-lg shadow-sm transition-all">
                  <span class="material-icons text-sm">verified</span>
                  ยืนยัน
                </button>

                <!-- Send/Preview PDF Button -->
                <button *ngIf="item.status !== '2'" (click)="sendToFullTaxReport(item)" [disabled]="isLoading"
                  class="inline-flex items-center gap-1.5 px-3 py-1.5 bg-amber-400 hover:bg-amber-500 disabled:opacity-50 disabled:cursor-not-allowed text-xs font-bold text-slate-900 rounded-lg shadow-sm transition-all">
                  <span class="material-icons text-sm">send</span>
                  แสดงตัวอย่างรายงาน
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Standard Pagination Footer -->
    <div class="flex flex-col sm:flex-row items-center justify-between gap-4 mt-6">
      <!-- Left: Item Range Info & Page Size Selection -->
      <div class="flex items-center gap-3">
        <span class="text-xs font-semibold text-slate-500 dark:text-slate-400">
          แสดง {{ startItemIndex }} - {{ endItemIndex }} จาก {{ totalItems }} รายการ
        </span>

        <!-- Page Size Selection Dropdown -->
        <div class="relative">
          <button (click)="togglePageSizeDropdown()" (blur)="closePageSizeDropdown()"
            class="flex items-center gap-1.5 px-3 py-1.5 bg-white dark:bg-slate-900 border border-slate-200/80 dark:border-slate-700 rounded-xl text-xs font-bold text-slate-700 dark:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-700 focus:outline-none focus:ring-1 focus:ring-amber-400 cursor-pointer transition-all shadow-sm">
            <span>{{ pageSize }} / หน้า</span>
            <span class="material-icons text-slate-400 text-sm transition-transform duration-200"
              [class.rotate-180]="isPageSizeDropdownOpen">expand_more</span>
          </button>

          <div *ngIf="isPageSizeDropdownOpen" (mousedown)="$event.preventDefault()"
            class="absolute bottom-full left-0 mb-1.5 z-50 min-w-[5rem] bg-white dark:bg-slate-800 border border-slate-100 dark:border-slate-700 rounded-xl shadow-lg py-1 animate-fade-in text-center">
            <button *ngFor="let opt of pageSizeOptions" (click)="selectPageSize(opt)"
              class="w-full text-center px-3 py-2 text-xs font-bold text-slate-700 dark:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-600 block transition-colors cursor-pointer">
              {{ opt }} / หน้า
            </button>
          </div>
        </div>
      </div>

      <!-- Right: Pagination Buttons -->
      <div class="flex items-center gap-1">
        <!-- Prev Page -->
        <button (click)="setPage(currentPage - 1)" [disabled]="currentPage === 1"
          class="w-8 h-8 rounded-lg border border-slate-200/60 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-450 dark:text-slate-300 disabled:opacity-40 hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors flex items-center justify-center cursor-pointer">
          <span class="material-icons text-sm">chevron_left</span>
        </button>

        <!-- Numbered Pages -->
        <ng-container *ngFor="let page of pagesArray">
          <!-- Active Page -->
          <button *ngIf="page === currentPage"
            class="w-8 h-8 rounded-lg bg-amber-400 text-slate-900 font-bold shadow-[0_4px_12px_rgba(251,191,36,0.35)] flex items-center justify-center text-xs">
            {{ page }}
          </button>

          <!-- Inactive Page -->
          <button *ngIf="page !== currentPage" (click)="setPage(page)"
            class="w-8 h-8 rounded-lg text-slate-700 dark:text-slate-300 font-bold hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 transition-colors flex items-center justify-center text-xs cursor-pointer">
            {{ page }}
          </button>
        </ng-container>

        <!-- Next Page -->
        <button (click)="setPage(currentPage + 1)" [disabled]="currentPage === totalPages"
          class="w-8 h-8 rounded-lg border border-slate-200/60 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-450 dark:text-slate-300 disabled:opacity-40 hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors flex items-center justify-center cursor-pointer">
          <span class="material-icons text-sm">chevron_right</span>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Glassmorphism PDF Preview Modal -->
<div *ngIf="isPdfPreviewOpen"
  class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in">
  <div
    class="relative w-full max-w-5xl h-[90vh] bg-white border border-slate-100 rounded-[2rem] shadow-2xl overflow-hidden flex flex-col animate-fade-in-up">
    <!-- Modal Header -->
    <div class="flex items-center justify-between px-6 py-4 border-b border-slate-100">
      <div>
        <h3 class="text-lg font-black text-slate-800">
          แสดงตัวอย่างรายงาน Full Tax
        </h3>
        <p class="text-xs font-semibold text-slate-400 mt-0.5" *ngIf="previewingInvoice">
          เลขที่ใบกำกับภาษี: <span class="text-amber-500 font-bold">{{ previewingInvoice.receiptId }}</span> | ลูกค้า:
          {{ previewingInvoice.customerName }}
        </p>
      </div>
      <button (click)="closePdfPreview()"
        class="w-9 h-9 rounded-xl bg-slate-100 text-slate-500 hover:bg-slate-200 transition-colors flex items-center justify-center shadow-sm">
        <span class="material-icons text-lg">close</span>
      </button>
    </div>

    <!-- Modal Content: Embedded PDF Viewer -->
    <div class="flex-1 bg-slate-100/50 p-4 relative overflow-hidden">
      <iframe *ngIf="pdfUrl" [src]="pdfUrl" class="w-full h-full border-none rounded-2xl shadow-inner bg-white">
      </iframe>
      <div *ngIf="!pdfUrl" class="w-full h-full flex flex-col items-center justify-center text-slate-400">
        <span class="material-icons text-5xl animate-spin text-amber-500">autorenew</span>
        <p class="text-sm font-bold mt-3">กำลังเตรียมไฟล์ PDF...</p>
      </div>
    </div>

    <!-- Modal Footer Actions -->
    <div class="px-6 py-4 border-t border-slate-100 flex items-center justify-end gap-3 bg-slate-50/50">
      <button (click)="closePdfPreview()"
        class="px-5 py-2 bg-slate-100 hover:bg-slate-200 text-sm font-bold text-slate-700 rounded-xl transition-colors shadow-sm">
        ปิดหน้าต่าง
      </button>
    </div>
  </div>
</div>

<!-- Edit Modal Component -->
<app-modal-full-tax-report-edit *ngIf="isEditModalOpen && editingInvoiceId" [invoiceId]="editingInvoiceId"
  (close)="closeEditModal()" (saveSuccess)="onEditSuccess()">
</app-modal-full-tax-report-edit>

<app-pss-confirm-modal *ngIf="isConfirmModalOpen" title="ยืนยันใบกำกับภาษี?" message="ยืนยันใบกำกับภาษี"
  [highlight]="confirmTarget?.receiptId || ''"
  messageSuffix="หลังยืนยันแล้วจะไม่สามารถแก้ไขข้อมูลได้" confirmLabel="ยืนยัน" icon="verified" variant="warning"
  [showIrreversibleNote]="true" (confirm)="confirmFullTaxInvoice()" (cancel)="closeConfirmModal()">
</app-pss-confirm-modal>

<!-- Full Screen Loading Overlay -->
<app-pss-loading *ngIf="isLoading"></app-pss-loading>